<template>
  <div id="divHealthWarningsWrapper" class="static-page-holder">
    <VueWrapperNarrow>
      <div class="hw-wrapper" v-html="content"></div>
    </VueWrapperNarrow>
  </div>
</template>

<script>
import VueWrapperNarrow from '@/components/brand/VueWrapperNarrow/VueWrapperNarrow.vue';
import StaticContent from '@/services/Api/staticContents';
export default {
  name: 'HealthWarnings',
  components: { VueWrapperNarrow },
  data() {
    return { content: '' };
  },
  created() {
    StaticContent.getStaticContent('SaglikUyarilari').then(res => {
      let {
        Data: { content },
      } = res.data;
      this.content = content;
    });
  },
};
</script>

<style lang="scss">
//TODO: BackEnd Servisleri düzeldikten sonra düzenlenecek
.hw-wrapper {
  text-align: center;
  padding: palette-space-level('60') 0;
  white-space: pre-line;
}

.img-thumbnail {
  border: none !important;
  border-radius: palette-space-level(3);
}
</style>
